module.exports = __webpack_public_path__ + "img/background-tech.b604e553.jpg";